module.exports = __webpack_public_path__ + "img/clevermadeeasy-thumb.8dd81989.jpg";